// The long-lived objects of the running application: one database, one
// session manager, one synchronisation engine, one geolocation service.
// Screens reach them through the context; tests build their own.
// INC-05b: and one photo queue, beside the engine, on the same client.
// D-208: and one install service, which knows what this device can do about
// installing the application and remembers a dismissal of the invitation.
// D-225: and one agenda refresher, which brings back what changed while the
// engine sends what waits.
// D-83: and the field's runtime, which starts the pieces that run on their own
// only for a session of the role that works in the field.
import { db } from '../db/database';
import { AgendaRefresher } from '../planning/refresh';
import { GeoService } from '../geo/service';
import { FieldRuntime } from './fieldRuntime';
import { InstallService } from './install';
import { requestPersistentStorage } from './storage';
import { SessionManager } from '../session/manager';
import { SyncEngine } from '../sync/engine';
import { PhotoQueue } from '../sync/photoQueue';

export const session = new SessionManager({ db });
// INC-06b-2a: nothing is sent without a session. A signed out, revoked or
// suspended session keeps its queue whole and sends none of it; the cycle that
// follows the next sign in does.
// INC-06b-2b (D-187): and nothing of another operator is sent under this
// session; the queues read the signed-in operator from the same snapshot.
const currentAuthor = (): string | null => session.getSnapshot().profile?.user.id ?? null;
export const engine = new SyncEngine({
  db,
  api: session.api,
  hasSession: () => session.getSnapshot().status === 'authenticated',
  currentAuthor,
});
export const photos = new PhotoQueue({ db, api: session.api, currentAuthor });
export const geo = new GeoService();
export const install = new InstallService({ db });
// B-50 (D-435): the browser's offer is heard from the page's first moment,
// before anybody signs in, which is when Chrome usually makes it; only the
// field's runtime takes it from the browser, for an operator's invitation.
install.listen();
export const agenda = new AgendaRefresher({ db, session });
export const field = new FieldRuntime({
  session,
  engine,
  photos,
  agenda,
  install,
  persistStorage: () => requestPersistentStorage(db),
});
